import {Business, MutationInviteFamilyFriendUserArgs, QueryBusinessArgs, QueryUsersForBusinessArgs, User, UserList} from "@irati/types"
import {createUseLazyQuery, createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import setIfNotSet from "@irati/utils/setIfNotSet"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import getUsersForBusiness from "./services/queries/usersForBusiness"
import teamsPaginated from "./services/queries/teamsPaginated"
import {gql} from "@apollo/client"
import {inviteFamilyFriendUserErrorHandler} from "./services/errors/familyFriendsErrorHandler"

const useLazyUsersForBusinessBase = createUseLazyQuery<UserList, QueryUsersForBusinessArgs>(getUsersForBusiness, {
  key: "usersForBusiness"
})

export const useLazyUsersForBusiness: typeof useLazyUsersForBusinessBase = (variables, options) => {
  const {business} = useAuth()
  setIfNotSet(variables, "includeBusiness", false)
  setIfNotSet(variables, "includeTeams", false)
  setIfNotSet(variables, "includeIntegrations", false)
  setIfNotSet(variables, "businessId", business?.uuid)
  return useLazyUsersForBusinessBase(variables, options)
}

const useUsersForBusinessBase = createUseQuery<UserList, QueryUsersForBusinessArgs>(getUsersForBusiness, {
  key: "usersForBusiness"
})

export const useUsersForBusiness: typeof useUsersForBusinessBase = (variables, options) => {
  const {business} = useAuth()
  setIfNotSet(variables, "includeBusiness", false)
  setIfNotSet(variables, "includeIntegrations", false)
  setIfNotSet(variables, "includeTeams", false)
  setIfNotSet(variables, "businessId", business?.uuid)
  return useUsersForBusinessBase(variables, options)
}

export const useLazyTeamsPaginated = createUseLazyQuery(teamsPaginated, {
  key: "teamsPaginated"
})

export const useInviteFamilyFriendUser = createUseMutation<User, MutationInviteFamilyFriendUserArgs>(
  gql`
    mutation InviteFriendsFamilyUser($user: InviteFamilyFriendUserInput!) {
      inviteFamilyFriendUser(user: $user) {
        uuid
        firstName
        lastName
        email
      }
    }
  `,
  {
    key: "inviteFamilyFriendUser",
    errorHandlers: [inviteFamilyFriendUserErrorHandler]
  }
)

export const useLazyCompanyManagers = createUseLazyQuery<Business, QueryBusinessArgs>(
  gql`
    query CompanyManagers($businessId: ID!) {
      business(businessId: $businessId) {
        uuid
        teamManagers {
          uuid
          email
          firstName
          lastName
          teams {
            results {
              uuid
              teamName
              managers {
                results {
                  uuid
                }
              }
            }
          }
        }
      }
    }
  `,
  {
    key: "businessManagers"
  }
)
